import React, { useContext, useState } from "react"
import { FilterContext } from "../../context/FilterContext"
import { RegistrationsContext } from "../../context/RegistrationsContext"
import { extractChartData, filterAndCombine, formatNumber, getDataTotal } from "../../util"
import { BarGraphCard } from "../GraphCard"
import { ToggleGroup, ToggleButton } from "../ToggleGroup"

import "./RegistrationsChart.css"

const RegistrationsChart: React.FC = () => {
	const { registrations, loading } = useContext(RegistrationsContext)
	const { totalDashboards, totalSwaps, totalSelected } = useContext(FilterContext)
	const [dataType, setDataType] = useState<"registrations" | "amount">("registrations")

	const totalValue = getDataTotal(filterAndCombine(registrations, totalSelected), dataType)
	const chartData = extractChartData(filterAndCombine(registrations, totalSelected), dataType, "date")

	const options = [
		{ value: "registrations", label: "Transactions" },
		{ value: "amount", label: "Amount" }
	]

	const formatter = (value: any) => {
		if (dataType === "amount") {
			return `$${formatNumber(value)}`
		}
		return formatNumber(value)
	}

	return (
		<BarGraphCard
			xKey="date"
			className="registration-graph"
			data={chartData}
			title="FTD"
			keys={{dashboards: totalDashboards, swaps: totalSwaps}}
			figureText={dataType === "amount" ? `$${formatNumber(totalValue)}` : formatNumber(totalValue)}
			loading={loading}
			filtered={true}
			filterValues={options.map(opt => opt.label)}
			filterSelected={options.find(opt => opt.value === dataType)?.label}
			onFilterChange={(value) => setDataType(value === "Amount" ? "amount" : "registrations")}
			formatter={formatter}
		/>
	)
}

export default RegistrationsChart